import axios from "axios";
import { ApiRouteHelpers } from "../root/apiRoutes";
import { OrganizationPublicId } from "../service/server/Types";
import { useCallback } from "react";

export interface UseRequestCSVDownloader {
  downloadRequests: (batchPublicIdOrRequestPublicIdList: string | string[]) => Promise<void>;
}

export interface UseRequestCSVDownloaderProps {
  orgId: OrganizationPublicId;
}

export function useRequestCSVDownloader({
  orgId,
}: UseRequestCSVDownloaderProps): UseRequestCSVDownloader {
  const downloadRequests = useCallback(
    async (batchPublicIdOrRequestPublicIdList?: string | string[]) => {
      const payload = Array.isArray(batchPublicIdOrRequestPublicIdList)
        ? {
            strategy: "list",
            list: batchPublicIdOrRequestPublicIdList,
          }
        : {
            strategy: "batch",
            batchPublicId: batchPublicIdOrRequestPublicIdList,
          };

      try {
        const response = await axios.post(ApiRouteHelpers.organizationRequestsCsv(orgId), payload, {
          responseType: "blob", // important for CSV download
        });
        const blob = new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        // Create a link element for download...
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `requests_${new Date().toLocaleDateString()}.csv`);

        // ...append it to the body to make it work in Firefox :)
        document.body.appendChild(link);
        link.click();

        // Clean up and remove the link element
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading CSV:", error);
      }
    },
    [orgId],
  );

  return {
    downloadRequests,
  };
}
